import { FilterColumn, FilterProvider } from './FilterManager';
import { CheckParameter, FilterParameter } from './FilterParameters';
import { dialog } from '../Dialog';
import { Control } from '@Common/Controls';
import { Label } from '../Label';
import { CheckBox, GridLayout, IGridCellDescription, IGridRowDescription } from '../index';
import { FilterOperation } from './FilterOperations';

export class FilterDialog {
    private onOkHander: () => void = $.noop;
    private root: GridLayout;

    constructor(private column: FilterColumn, private operation: FilterOperation, private provider: FilterProvider) {
        const parameters = operation.getParameters();
        const length = parameters.length;

        this.root = new GridLayout({
            rows: _.times(length, () => {
                return { style: { height: 'auto' } };
            }),
            columns: [{ style: { width: 'auto' } }, { style: { width: '*' } }],
            cells: _.flatMap(parameters, (p: FilterParameter, i: number) => {
                let editor;
                let lableText = p.getCaption();

                // TODO : making on visit;
                if (p instanceof CheckParameter) {
                    editor = new CheckBox({ caption: p.getCaption() });
                    editor.onChange(check => p.value(check));
                    lableText = '';
                } else {
                    editor = this.provider.createEditor(column.getEditorType());
                    editor.value(p.value());
                    editor.onChange(val => {
                        p.value(val);
                    });
                }

                return [
                    {
                        rowIndex: i,
                        columnIndex: 0,
                        content: new Label({ caption: lableText, width: 'auto', css: { textAlign: '' } }),
                        style: { paddingRight: '5px' }
                    },
                    {
                        rowIndex: i,
                        columnIndex: 1,
                        content: editor
                    }
                ];
            })
        });
    }

    public show() {
        const d = dialog({
            isModal: true,
            title: this.operation.description() + ' : ' + this.column.getColumn().title(),
            minWidth: 200,
            width: 400
        });
        d.wrap(this.root);
        d.resize({ force: true });
        d.ok(this.onOkHander);
    }

    public onOk(fn: () => void) {
        this.onOkHander = fn;
    }
}

interface IAccordingPanelSetting {
    sections: IAccordingPanelSection[];
    activeSection?: any;
}

interface IAccordingPanelSection {
    id?: string;
    title: string;
    withCheck?: boolean;
    content: any; //BaseControl || string || JQuery
}

class AccordingPanel implements Control {
    private layout: GridLayout;
    private enabled: boolean;
    private contentHeight: number;
    private activeSection: number;

    private static titleClass = 'accordingPanel-title';
    private static contentClass = 'accordingPanel-cell';
    private static activeClass = 'accordingPanel-active';

    constructor(setting: IAccordingPanelSetting) {
        const cells: IGridCellDescription[] = [];
        const rows: IGridRowDescription[] = [];

        this.activeSection = setting.activeSection || 0;

        _.forEach(setting.sections, (section: IAccordingPanelSection, index: number) => {
            const titleRow: IGridRowDescription = { style: { height: 'auto' } };
            const titleCell: IGridCellDescription = {
                columnIndex: 0,
                rowIndex: 2 * index + 0,
                content: section.title,
                className: AccordingPanel.titleClass,
                onClick: cell => {
                    this.layout.setRowStyle(2 * this.activeSection + 1, { display: 'none' });
                    this.activeSection = index;
                    this.layout.setRowStyle(2 * this.activeSection + 1, {
                        display: '',
                        height: this.contentHeight + 'px'
                    });
                    (cell.cell as JQuery).addClass(AccordingPanel.activeClass);
                }
            };
            const contentRow: IGridRowDescription = {};
            const contentCell: IGridCellDescription = {
                columnIndex: 0,
                rowIndex: 2 * index + 1,
                content: section.content,
                className: AccordingPanel.contentClass
            };

            rows.push(titleRow, contentRow);
            cells.push(titleCell, contentCell);
        });

        this.layout = new GridLayout({
            columns: [{}],
            rows: rows,
            cells: cells
        });
    }

    public getControl(): JQuery {
        return this.layout.getControl();
    }

    public setState(enabled: boolean) {
        this.enabled = enabled;
    }

    public adjust(width, height) {
        this.layout.adjust(width, height);
        let titleRowHeight = 0;
        $('.accordingPanel-title:parent', this.layout.getControl()).each((i, e) => {
            titleRowHeight += $(e).height();
        });
        this.contentHeight = this.layout.getControl().height() - titleRowHeight;
        this.layout.setRowStyle(this.activeSection * 2 + 1, { height: this.contentHeight + 'px' });
    }
}
